import { Menu, MenuButton, MenuItem, MenuList, Portal } from '@chakra-ui/react'
import { faClone, faEllipsis } from '@fortawesome/pro-regular-svg-icons'
import { useRecoilState } from 'recoil'
import { ItList } from 'types/graphql'

import {
  creatorDraftItListsState,
  creatorLiveItListsState,
} from 'src/atoms/creator.atom'
import useItListOverflowMenu from 'src/lib/hooks/useItListOverflowMenu'

import DeleteItListMenuItem from '../../DeleteItListMenuItem/DeleteItListMenuItem'
import Icon from '../../Icon/Icon'

const ContextMenu: React.FC<{
  itList: Pick<ItList, 'id' | 'name' | 'status'>
}> = ({ itList }) => {
  const [draftItLists, setDraftItLists] = useRecoilState(
    creatorDraftItListsState
  )
  const [liveItLists, setLiveItLists] = useRecoilState(creatorLiveItListsState)
  const { onClone, isOpen, setIsOpen, ref } = useItListOverflowMenu(itList)

  const onDeleted = () => {
    setDraftItLists(draftItLists.filter((draft) => draft.id !== itList.id))
    liveItLists?.length &&
      setLiveItLists(liveItLists?.filter((live) => live.id !== itList.id))
  }

  return (
    <Menu variant="context" isOpen={isOpen}>
      <MenuButton
        data-testid="itListCard-elipsisMenu"
        ref={ref}
        p={1}
        onClick={(ev) => {
          ev.preventDefault()
          ev.stopPropagation()
          setIsOpen((s) => !s)
        }}
      >
        <Icon boxSize="18px" icon={faEllipsis} />
      </MenuButton>
      <Portal>
        <MenuList>
          <MenuItem
            data-testid="overflowMenu-cloneButton"
            icon={<Icon icon={faClone} fontSize={16} w="18px" />}
            onClick={onClone}
          >
            Clone{itList.status === 'published' && ' to Drafts'}
          </MenuItem>
          <DeleteItListMenuItem
            itList={itList}
            label="Delete"
            closeMenu={() => setIsOpen(false)}
            onDeleted={onDeleted}
          />
        </MenuList>
      </Portal>
    </Menu>
  )
}

export default ContextMenu
